"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const MEMBER_VENUE_EXCLUSION_TYPES = {
    HR_ISSUE: "HR_ISSUE",
    EXCLUDED_BY_CLIENT: "EXCLUDED_BY_CLIENT",
    EXCLUDED_BY_CANDIDATE: "EXCLUDED_BY_CANDIDATE",
};
exports.default = MEMBER_VENUE_EXCLUSION_TYPES;
